import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider, useSite } from "./context/SiteContext";
import Header from "./components/site/Header";
import Footer from "./components/site/Footer";
import ChatWidget from "./components/site/ChatWidget";
import FloatingContact from "./components/site/FloatingContact";
import { onContactClick } from "./lib/contactTrack";
import Home from "./pages/Home";
import Bulk from "./pages/Bulk";
import Prices from "./pages/Prices";
import StatePage from "./pages/StatePage";
import StatesIndex from "./pages/StatesIndex";
import Track from "./pages/Track";
import Review from "./pages/Review";
import LeaveReview from "./pages/LeaveReview";
import ShortLink from "./pages/ShortLink";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";

const Loader = () => (
  <div className="flex min-h-screen items-center justify-center bg-white">
    <img src="/logo.png" alt="StripWise" className="h-12 animate-pulse" />
  </div>
);

const PublicLayout = () => {
  const { content } = useSite();
  useEffect(() => {
    document.addEventListener("click", onContactClick, true);
    return () => document.removeEventListener("click", onContactClick, true);
  }, []);
  if (!content) return <Loader />;
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main><Outlet /></main>
      <Footer />
      <ChatWidget />
      <FloatingContact />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/chat" element={<Home />} />
              <Route path="/quote" element={<Home />} />
              <Route path="/bulk" element={<Bulk />} />
              <Route path="/prices" element={<Prices />} />
              <Route path="/sell-test-strips" element={<StatesIndex />} />
              <Route path="/track" element={<Track />} />
              <Route path="/review/:token" element={<Review />} />
              <Route path="/leave-review" element={<LeaveReview />} />
              <Route path="/sell-test-strips/:slug" element={<StatePage />} />
              <Route path="/sell-test-strips/:slug/:city" element={<StatePage />} />
            </Route>
            <Route path="/wa" element={<ShortLink kind="whatsapp" />} />
            <Route path="/text" element={<ShortLink kind="text" />} />
            <Route path="/call" element={<ShortLink kind="call" />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="*" element={<PublicLayout />}>
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </SiteProvider>
    </div>
  );
}

export default App;
